import axios from "axios";
import { data } from "jquery";
import API from "../helpers/endpointService";
import {successAlert,warningAlert} from "../components/custom/alert";

export const addshipbasicinfo = (data, formData, id, arr) => {
  let apiUrl = API.ADDEDIT_PROJECT;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
     if (response?.status === 200) {
          localStorage.setItem("addeditid", response.data)
          if(arr.length == 0){
            dispatch({ type: "SHOW_LOADER", data: false })
            if(id===0){
              successAlert("Ship created successfully.");
            }else{
              successAlert("Shipdetails updated successfully.");
            }
          }
          if(arr.length > 0){
            if(id == 0){
              dispatch(addshiplogoinfo(formData, response.data,"New"))
            }if(id != 0){
              dispatch(addshiplogoinfo(formData, id,"Edit"))
            }
          }
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const addshipinchargeinfo = (data, access) => {
  let apiUrl = API.ADDEDITINCHARGE_PROJECT;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      headers: {
        'key': access
      }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const putshipinchargeinfo = (data, access) => {
  let apiUrl = API.ASSIGN_USER;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      headers: {
        'key': access
      }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          successAlert("Data saved successfully.");
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const addshiplogoinfo = (formData, id,type) => {
  let apiUrl = API.ADDEDIT_LOGO + "?id=" + id;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: formData,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          if(type==="New"){
            successAlert("Ship created successfully.");
          }else{
            successAlert("Shipdetails updated successfully.");
          }
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const getshipbasicinfo = (data) => {
 
    let apiUrl = API.ADDEDIT_PROJECT + data;
   
    return (dispatch) => {
      axios({
        method: "get",
        url: apiUrl,
        data: data,
      })
        .then((response) => {
          if (response?.status === 200) {
              localStorage.setItem("ShipName", response.data?.ShipName)
              localStorage.setItem("BasicInfo", JSON.stringify(response?.data))
            dispatch({ type: "GETBASICINFO_PROJECT", data: response.data });
          } else {
          }
        })
        .catch((error) => {
          dispatch({ type: "SHOW_LOADER", data: false })
            warningAlert("Something went wrong. Please try again.");
          if (error?.response?.status === 401) {
            
            // logOut();
          }
        });
    };
  
};

export const filedeleteshiplogo = (id, name) => {
  let apiUrl = API.ADDEDIT_PROJECT + 'logo/' + id + '?uniquefilename=' + name;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const deleteship = (data) => {
  let apiUrl = API.ADDEDIT_PROJECT + data;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
};

export const getSettingsDateFormat = () => {
  let apiUrl = API.SETTINGS_PROJECT + 'TimeFormat';
  return (dispatch) => {
    // dispatch({type:"SHOW_LOADER",data:true})
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (response?.status === 200) {
          dispatch({ type: "FORMAT_VALUES", data: response.data });

        } else {

        }
      })
      .catch((error) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
  //   var tempData = [
  //     {
  //         Id: 1,
  //         Convertion: "yyyy-MM-dd"
  //     },
  //     {
  //         Id: 3,
  //         Convertion: " MMM dd yy"
  //     },
  //     {
  //       Id: 4,
  //       Convertion: " yyyy MMM dd "
  //   },
  // ];
  // return (dispatch) => {
  //   dispatch({ type: "FORMAT_VALUES", data: tempData });
  // };
};

export const postSettingsDateFormat = (data) => {
  let apiUrl = API.SETTINGS_PROJECT_POST;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          // dispatch(postSettingsTimeszones(data1))
          // dispatch({ type: "FORMAT_VALUES", data: response.data });
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
  //   var tempData = [
  //     {
  //         Id: 1,
  //         Convertion: "yyyy-MM-dd"
  //     },
  //     {
  //         Id: 3,
  //         Convertion: " MMM dd yy"
  //     },
  //     {
  //       Id: 4,
  //       Convertion: " yyyy MMM dd "
  //   },
  // ];
  // return (dispatch) => {
  //   dispatch({ type: "FORMAT_VALUES", data: tempData });
  // };
};

export const getSettingsTimeszones = () => {
  let apiUrl = API.SETTINGS_PROJECT + "TimeZone";
  return (dispatch) => {
    // dispatch({type:"SHOW_LOADER",data:true})
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (response?.status === 200) {
          dispatch({ type: "TIME_VALUES", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  //   var tempData = [
  //     {
  //       Id: 1,
  //       TimeZoneName: "(GMT+02=00) Harare,Pretoria	"

  //   },
  //   {
  //       Id: 3,
  //       TimeZoneName: "(GMT-06=20) Central America		"
  //   }, 
  //   {
  //     Id: 3,
  //     TimeZoneName: "(GMT+02=00) Greenland	"
  // },   
  // ];
  // return (dispatch) => {
  //   dispatch({ type: "TIME_VALUES", data: data });
  // };
};

export const postSettingsTimeszones = (data) => {
  let apiUrl = API.SETTINGS_PROJECT + "TimeZone?timeZoneId=" + data.timeZoneId + "&projectId=" + data.ProjectId;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          // dispatch({ type: "TIME_VALUES", data: response.data });
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const gethistorylogshipdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=Project'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
